import type { CircleReviewSource } from "@circle-react/types/CommunityReview";
import { create } from "zustand";

interface ReviewSubmissionModalState {
  close: () => void;
  // Whether this page load already decided on the invitation modal. Lives here
  // so it survives the feed remounting on route changes and tests can reset it.
  hasEvaluatedInvitation: boolean;
  isOpen: boolean;
  markInvitationEvaluated: () => void;
  open: (source: CircleReviewSource) => void;
  // Where the modal was opened from. Kept after closing so the source is still
  // known while the modal animates out.
  source: CircleReviewSource;
}

// Shared by everything that can open the review form: the feed banner and the
// invitation modal.
export const useReviewSubmissionModalStore = create<ReviewSubmissionModalState>(
  set => ({
    hasEvaluatedInvitation: false,
    isOpen: false,
    source: "circle_feed_banner",
    open: source => {
      set({ isOpen: true, source });
    },
    close: () => {
      set({ isOpen: false });
    },
    markInvitationEvaluated: () => {
      set({ hasEvaluatedInvitation: true });
    },
  }),
);
